// import React, { useEffect, useState } from "react";
// import PaymentForm from "./PaymentForm";
// import PaymentList from "./PaymentList";

// const PaymentsPage = () => {
//   const [payments, setPayments] = useState([]);
//   const [showForm, setShowForm] = useState(false);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     loadPayments();
//   }, []);

//   const loadPayments = async () => {
//     setLoading(true);
//     try {
//       const res = await fetch("http://localhost/erp/payments/list.php");
//       const data = await res.json();
//       setPayments(data.payments || []);
//     } catch (err) {
//       console.error("Error loading payments:", err);
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-8">
//       <div className="max-w-7xl mx-auto space-y-8">
//         {/* Header */}
//         <div className="flex justify-between items-center border-b pb-4">
//           <div>
//             <h1 className="text-3xl font-bold text-gray-900">
//               Payments Management
//             </h1>
//             <p className="text-gray-500 text-sm">
//               Weekly interest tracking system (8-day cycle)
//             </p>
//           </div>

//           {!showForm && (
//             <button
//               onClick={() => setShowForm(true)}
//               className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2 rounded-lg font-semibold"
//             >
//               + Add Payment
//             </button>
//           )}
//         </div>

//         {/* Content */}
//         {showForm ? (
//           <PaymentForm
//             onSuccess={() => {
//               loadPayments();
//               setShowForm(false);
//             }}
//             onCancel={() => setShowForm(false)}
//           />
//         ) : (
//           <div className="bg-white rounded-xl shadow border">
//             {loading ? (
//               <div className="p-10 text-center text-gray-500">
//                 Loading payments...
//               </div>
//             ) : (
//               <PaymentList payments={payments} />
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PaymentsPage;




import React, { useEffect, useState } from "react";
import PaymentForm from "./PaymentForm";
import PaymentList from "./PaymentList";
import { Api } from "../Api/Api";

const PaymentsPage = () => {
  const [payments, setPayments] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPayments();
  }, []);

  const loadPayments = async () => {
    setLoading(true);
    try {
    
      const res = await fetch(`${Api}payments/list.php`);
      const data = await res.json();
      setPayments(data.payments || []);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
    
      <div className="max-w-7xl mx-auto space-y-6">
        <div className="flex justify-between items-center border-b pb-3">
          <h1 className="text-2xl font-bold">Payments Management</h1>

          {!showForm && (
            <button
              onClick={() => setShowForm(true)}
              className="bg-indigo-600 text-white px-4 py-2 rounded"
            >
              + Add Payment
            </button>
          )}
        </div>

        {showForm ? (
          <PaymentForm
            onSuccess={() => {
              loadPayments();
              setShowForm(false);
            }}
            onCancel={() => setShowForm(false)}
          />
        ) : (
          <PaymentList payments={payments} />
        )}
      </div>
    </div>
  );
};

export default PaymentsPage;
